"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TextHighlight = _styledComponents.default.span.withConfig({
  displayName: "TextHighlight",
  componentId: "ja9atc-0"
})(["", ";"], function (_ref) {
  var theme = _ref.theme,
      highlight = _ref.highlight,
      highlightLineHeight = _ref.highlightLineHeight;
  var textColor = theme.colors.textHighlight[highlight].textColor;
  var backgroundColor = theme.colors.textHighlight[highlight].backgroundColor;
  return (0, _styledComponents.css)(["display:inline;padding:4px;line-height:", ";color:", ";background:", ";box-shadow:", " 0 0 ", ",-", " 0 0 ", ";position:relative;left:", ";@media (min-width:", "){line-height:", ";}"], highlightLineHeight[0], textColor, backgroundColor, theme.space.xs, backgroundColor, theme.space.xs, backgroundColor, function (_ref2) {
    var theme = _ref2.theme;
    return theme.space.xs;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.breakpoints.md;
  }, highlightLineHeight[1]);
});

var _default = TextHighlight;
exports.default = _default;